export enum CnpjRevenueErrorEnum {
  cnpjInvalid = 1,
  cnpjNotFound = 2,
  cnpjNotActive = 3,
  existingCnpj = 4
}
